import { sdk } from '@needful-things-mvp/sdk';

/**
 * Minimal API configuration for the admin app.
 *
 * The API base URL and environment are provided at build time through
 * `VITE_API_URL` and `VITE_ENVIRONMENT`.
 *
 * The session id is held in an httpOnly cookie set by the API, so it is never
 * exposed to JavaScript. Only a non-sensitive "signed in" flag is stored here.
 */
export const API_URL = (
  (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3333'
).replace(/\/+$/, '');

// The shared SDK (OAuth popup, API calls) must target the same API origin.
sdk.setBaseUrl(API_URL);

/** Deployment environment for this build (`production`, `staging`, `development`). */
export const ENVIRONMENT = (import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? 'production';

/**
 * In development the login button skips OAuth and signs in locally. See
 * `pages/login.tsx`. Never enable this in a deployed build.
 */
export const IS_DEVELOPMENT = ENVIRONMENT === 'development';

export const AUTH_STORAGE_KEY = 'needful-things-mvp_authenticated';

/**
 * Handles a 401 from the API: drop the local auth flag and send the user to the
 * login page, preserving where they were so they land back there after signing
 * in. No-op if already on `/login`.
 */
export function handleUnauthorized(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY);
  if (typeof window === 'undefined') return;

  const { pathname, search } = window.location;
  if (pathname.startsWith('/login')) return;

  const target = `${pathname}${search}`;
  window.location.assign(`/login?redirect=${encodeURIComponent(target)}`);
}
